import React from 'react';
import * as S from './style';
import { Label } from 'components';
//import ZimssaConstant from 'commons/ZimssaConstant';

export interface Props {
    carImage: string;
    plateNumber: string;
    carInfo: string;
    color: string;
}

function Car({ carImage, plateNumber, carInfo, color }: Props): React.ReactElement {
    //const carColor = ZimssaConstant.CAR_INFO.COLOR.find((item) => item.value === color)?.color;

    return (
        <S.CarContainer>
            <S.CarImageWrapper backgroundImg={carImage}></S.CarImageWrapper>
            <S.CarInfoWrapper>
                <S.CarNumberWrapper>
                    <Label fontStyle={'body2'} color={'gray_opacity_800'} contents={plateNumber} />
                </S.CarNumberWrapper>
                <Label fontStyle={'subtitle'} color={'gray_opacity_600'} contents={carInfo} />
            </S.CarInfoWrapper>
        </S.CarContainer>
    );
}

export default Car;
